import { createAction } from 'redux-actions'

const SET_ADMIN = 'SET_ADMIN'

const setAdmin = createAction(SET_ADMIN)

export { setAdmin }
